import { InputAdornment, MenuItem, Select, TextField } from '@mui/material';
import React from 'react';

const AmountInput: React.FC<{
	value: number;
	inputType: '$' | '%';
	maxAmount: number;
	onChange: (value: number, inputType: '$' | '%') => void;
}> = ({ value, inputType, onChange, maxAmount }) => {
	return (
		<TextField
			type="number"
			size="small"
			value={value}
			sx={{
				minWidth: inputType === '$' ? '130px' : '90px',
				flexShrink: 0,
				display: {
					xs: 'none',
					sm: 'none',
					md: 'block',
				},
				transition: 'all 0.2s ease',
			}}
			slotProps={{
				htmlInput: {
					step: '0.01',
					min: 0,
					max: inputType === '$' ? maxAmount : 100,
				},
				input: {
					endAdornment: (
						<InputAdornment position="end" sx={{ pr: 0 }}>
							<Select
								value={inputType || '%'}
								onChange={(e) => {
									const newType = e.target.value;
									onChange(value, newType);
								}}
								variant="standard"
								disableUnderline
								displayEmpty
								renderValue={(selected) => (selected === '$' ? '$' : '%')}
								MenuProps={{
									disablePortal: true,
									sx: {
										minWidth: '100px',
										maxWidth: '150px',
										marginTop: '5px',
									},
								}}
							>
								<MenuItem value="$">Amount $</MenuItem>
								<MenuItem value="%">Percent %</MenuItem>
							</Select>
						</InputAdornment>
					),
				},
			}}
			onChange={(e) => {
				const newValue = parseFloat(e.target.value);
				onChange(newValue, inputType);
			}}
		/>
	);
};

export default AmountInput;
